export const DocsLink = 
  process.env.REACT_APP_BUILD_ENV === "development"
    ? "https://docs-test.padolabs.org/"
    : "https://docs.primuslabs.xyz/";
    
export const DEVHUBLink = 
  process.env.REACT_APP_BUILD_ENV === "development"
    ? "http://api-dev.padolabs.org:38089/"
    : "https://dev.primuslabs.xyz/";



export const RepuationLink = process.env.REACT_APP_BUILD_ENV === "development"
    ? "http://api-dev.padolabs.org:38098/home":"https://app.primuslabs.xyz/";

export const BASESERVICEAPI =
  process.env.REACT_APP_BUILD_ENV === "development"
    ? "https://api-dev.padolabs.org"
    : "https://api.padolabs.org";


console.log("process.env", process.env.REACT_APP_BUILD_ENV);